import { render, staticRenderFns } from "./MultipleImage.vue?vue&type=template&id=6607b8ac&scoped=true&"
import script from "./MultipleImage.vue?vue&type=script&lang=ts&"
export * from "./MultipleImage.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=6607b8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607b8ac",
  null
  
)

export default component.exports